exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  margin-top: 20px;\n  line-height: 1.5em; }\n\nblockquote {\n  font-style: italic;\n  text-align: center;\n  width: 450px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin: auto;\n  line-height: 2em; }\n\nli {\n  line-height: 1.5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/about/about.component.scss
// module id = ../../../../../src/app/pages/about/about.component.scss
// module chunks = main